<template>
  <div>
    <el-carousel :height="bannerHeight+'px'">
      <el-carousel-item v-for="(item, index) in bannerUrl" :key="index">
        <img
          ref="imgHeight"
          :src="item.value"
          alt=""
           @load="imgLoad"
          @click="onLink(item.linkUrl)"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: {
    bannerUrl: Array,
  },
  data() {
    return {
      bannerHeight: "",
    };
  },
  mounted() {
    this.imgLoad();
    window.addEventListener(
      "resize",
      () => {
        this.imgLoad();
      },
      false
    );
  },
  methods: {
    onLink(linkUrl) {
      if (linkUrl) {
        window.open(linkUrl, "_blank");
      }
    },
    imgLoad() {
      this.$nextTick(() => {
        let ref = this.$refs;
        this.bannerHeight =
          ref.imgHeight && ref.imgHeight.length ? ref.imgHeight[0].height : "";
      });
    },
  },
};
</script>

<style lang="less" scoped>
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/carousel/carousel.vue